import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Backdrop = styled.div<{ open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  will-change: background-color transition;
  transition: all 0.6s;

  ${({ open }) => {
    if (open) {
      return css`
        background-color: rgba(0, 0, 0, 1);
        opacity: 0.6;
        visibility: visible;
      `;
    } else {
      return css`
        visibility: hidden;
      `;
    }
  }}
`;
